import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import BarLoader from "react-spinners/BarLoader";
import { setAlert } from "../../../../actions/alert";
import { updateLocation } from "../../../../actions/currentLocation";
import {
  fetchSuggestions,
  updateRestaurant,
} from "../../../../actions/restaurantBuilder";
import { getLatLong } from "../../../../util/geoUtils";
import CheckUnauth from "../../../auth/CheckUnauth";
const RestaurantCreateSearch = ({
  updateRestaurant,
  suggestions,
  currRestaurant,
  updateLocation,
  setAlert,
}) => {
  const initialFormData = {
    name: "",
    location: "",
    suggested: false,
  };
  const [formData, setFormData] = useState(initialFormData);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(function stopLoadingWhenSuggestionsArrive() {
    suggestions && setLoading(false);
  }, [suggestions]);

  const { name, location: searchLocation, suggested } = formData;

  useEffect(function syncNameFromLocationState() {
    if (location.state) {
      const { name } = location.state;
      console.log(location.state);
      setFormData((data) => ({ ...data, name }));
    }
  }, [location.state]);

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const suggestMatches = async (e) => {
    e.preventDefault();
    setLoading(true);
    setLocation(searchLocation);
  };
  const setLocation = async (zipcode) => {
    console.log("hello world");
    if (zipcode && zipcode === "Use Current Location") {
      getUserLocation(fetchSuggestions(formData));
    } else if (zipcode && zipcode !== "") {
      const { lat, lng } = (await getLatLong(zipcode)).data;
      return updateLocation({ lat, lng }, fetchSuggestions(formData));
    }
  };
  const getUserLocation = (callback) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          updateLocation({ lat: latitude, lng: longitude }, callback);
        },
        (error) => {
          console.log("error getting position");
          console.log(error);
          if (error.message.includes("denied")) {
            alert("This requires location to be shared!");
          } else {
            setAlert(
              "Error retrieving your location, please try a city or zipcode instead",
              "failure"
            );
          }
          setLoading(false);
        }
      );
    }
  };
  if (suggested) {
    // return <Redirect to="/create/match" />;
    if (location.pathname.includes("v2")) {
      console.log(formData);
      console.log(name);
      const coordinates = currRestaurant.coordinates.split(", ");
      const geoJson = {
        coordinates: [
          parseFloat(coordinates[1]),
          parseFloat(coordinates[0]),
        ],
      };
      
      // Check if we have cuisine data (meaning we came from Address page and should go back)
      const hasCuisineData = location.state && (
        location.state.cuisine || 
        location.state.veganOptions ||
        location.state.allMenuItems
      );
      
      if (hasCuisineData) {
        // We came from Address page with cuisine data, go back to Address with location filled in
        navigate("/create/v2/address", {
          state: {
            ...location.state,
            address: currRestaurant.address,
            googleId: currRestaurant.googleId,
            geoJson,
            name: name || location.state.name,
          },
        });
      } else {
        // Normal flow - go to Cuisine page
        navigate("/create/v2/cuisine", {
          state: {
            ...location.state,
            address: currRestaurant.address,
            googleId: currRestaurant.googleId,
            geoJson,
            name,
          },
        });
      }
    } else {
      navigate("/create/match");
    }
  }
  return (
    // <div className="container h-100 ">
    <div className="row create-container">
      <CheckUnauth {...location} />
      <form className="form-container" onSubmit={(e) => suggestMatches(e)}>
        <div className="h3 form-title">
          Create a restaurant
        </div>
        <div className="form-section form-section-wide">
          <label className="form-label">Restaurant Name*</label>
          <div className="form-flex">
            <input
              className="text-form form-input-full"
              type="text"
              name="name"
              value={name}
              onChange={(e) => onChange(e)}
              required
            />
          </div>
        </div>

        <div className="form-section form-section-wide">
          <label className="form-label">Zipcode or city*</label>
          <div className="form-flex">
            <input
              className="text-form form-input-full"
              title="Zipcode or city"
              name="location"
              value={searchLocation}
              onChange={(e) => onChange(e)}
            />
            <button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                getUserLocation();
                setFormData({
                  ...formData,
                  location: "Use Current Location",
                });
              }}
            >
              <i class="fas fa-crosshairs" />
            </button>
          </div>
        </div>
        <input
          className="btn-primary btn-center"
          style={{ height: "2em", margin: "8px" }}
          type="submit"
          value="Suggest Matches"
          disabled={loading}
        />
      </form>
      <BarLoader loading={loading} color="green" height="8px" />
      {suggestions && (
        <div className="col m-3 text-left form-container">
          {suggestions.map((suggestion) => (
            <div
              className="result"
              onClick={() => {
                console.log("hello world");
                updateRestaurant({
                  ...currRestaurant,
                  name,
                  address: suggestion.formatted_address,
                  city: suggestion.formatted_address.split(",")[1],
                  coordinates: `${suggestion.geometry.location.lat}, ${suggestion.geometry.location.lng}`,
                  googleId: suggestion.place_id,
                });
                setFormData({ ...formData, suggested: true });
              }}
              key={suggestion.place_id}
            >
              {suggestion.name}
              <br /> {suggestion.formatted_address}
              <hr />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  suggestions: state.restaurantBuilder.results,
  currRestaurant: state.restaurantBuilder.restaurant,
});
export default connect(mapStateToProps, {
  updateRestaurant,
  updateLocation,
  setAlert,
})(RestaurantCreateSearch);
